import React, { useEffect } from "react";
import { Endometriosis01 } from "./Endometriosis_01";
import { Endometriosis02 } from "./Endometriosis_02";
import { Cause01 } from "./Cause_01";
import { Types01 } from "./Types_01";
import { Types02 } from "./Types_02";
import { Types03 } from "./Types_03";
import { Diagnosis01 } from "./Diagnosis_01";
import { Diagnosis02 } from "./Diagnosis_02";
import { Diagnosis03 } from "./Diagnosis_03";
import { Diagnosis04 } from "./Diagnosis_04";
import { Diagnosis05 } from "./Diagnosis_05";
import { Symptoms01 } from "./Symptoms_01";
import { SEO } from "../SEO";

export const MoreInfoLayout: React.FC = () => {
    useEffect(() => {
        // Map Spanish URL hashes to English IDs
        const hashToIdMap: { [key: string]: string } = {
            "#causa": "cause",
            "#tipos": "types",
            "#sintomas": "symptoms",
            "#diagnostico": "diagnosis",
        };

        const handleHashChange = () => {
            const hash = window.location.hash;
            if (hash && hashToIdMap[hash]) {
                setTimeout(() => {
                    document.getElementById(hashToIdMap[hash])?.scrollIntoView({ behavior: "smooth" });
                }, 100);
            }
        };

        // Handle initial load
        handleHashChange();

        // Listen for hash changes
        window.addEventListener("hashchange", handleHashChange);

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    return (
        <>
            <SEO />
            <div className="more-info-section">
                <Endometriosis01 />
                <Endometriosis02 />
                <Cause01 />
                <Types01 />
                <Types02 />
                <Types03 />
                <Symptoms01 />
                <Diagnosis01 />
                <Diagnosis02 />
                <Diagnosis03 />
                <Diagnosis04 />
                <Diagnosis05 />
            </div>
        </>
    );
};